jQuery(function($){
  $('#hamburger').click(function(){
    $('#mobile-menu').addClass('active')
  });
  $('#mobile-menu-close').click(function(){
    $('#mobile-menu').removeClass('active')
  });
  $('#mobile-menu .mobile-menu__menu a[href^="#"]').click(function(){
    $('#mobile-menu').removeClass('active')
  });
  $(".accordion__header").click(function() {
    $(this).parent().toggleClass("open")
  });
})